import React from "react";
import Login from "../../pages/auth/Login.jsx";
import Empresas from "../../pages/auth/Empresas.jsx";
import RedefinirSenha from "../../pages/auth/RedefinirSenha.jsx";
import ResetSenha from "../../pages/auth/ResetSenha.jsx";
import Congelada from "../../pages/auth/Congelada.jsx";

const prefix = process.env.REACT_APP_PREFIX;

const authRoutes = [
  {
    path: `${prefix}/login/`,
    component: <Login />,
    title: "login",
    noStatic: true,
  },
  {
    path: `${prefix}/login/empresas/`,
    component: <Empresas />,
    title: "empresas",
    noStatic: true,
  },
  {
    path: `${prefix}/UserRecovery/`,
    component: <RedefinirSenha />,
    title: "redefinir senha",
    noStatic: true,
  },
  {
    path: `${prefix}/UserRecovery/reset/`,
    component: <ResetSenha />,
    title: "redefinir senha",
    noStatic: true,
  },
  {
    path: `${prefix}/congelada/Congelada/`,
    component: <Congelada />,
    title: "congelada",
    noStatic: true,
  },
];

export default authRoutes;
